// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MenuLayout from "./layout/Menu.jsx";
import Home from "./views/Home.jsx";
import Dashboard from "./views/Dashboard.jsx";

import InventarioView from "./views/InventarioView";
import InventarioForm from "./components/InventarioForm";

import ContratosView from "./views/ContratosView";
import ContratoForm from "./components/ContratoForm";

import CredencialesView from "./views/CredencialesView.jsx";
import CredencialForm from "./components/CredencialForm.jsx";

import IncidenciasCrear from "./views/incidencias/IncidenciasCrear";
import IncidenciasListado from "./views/incidencias/IncidenciasListado";

import ReemplazosView from "./views/ReemplazosView.jsx";
import Configuracion from "./views/Configuracion";

import ReportesComparativo from "./views/reportes/ReportesComparativo.jsx";

import AuthGate from "./auth/AuthGate";
import LoaderGate from "./utils/LoaderGate";
import Callback from "./pages/Callback.jsx";
import Logout from "./auth/Logout";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ================= PUBLICAS ================= */}
        <Route path="/callback" element={<Callback />} />
        <Route path="/logout" element={<Logout />} />

        {/* ================= PRIVADAS ================= */}
        <Route
          path="/"
          element={
            <AuthGate>
              <LoaderGate>
                <MenuLayout />
              </LoaderGate>
            </AuthGate>
          }
        >
          {/* HOME */}
          <Route index element={<Home />} />

          {/* DASHBOARD */}
          <Route path="dashboard" element={<Dashboard />} />

          {/* INVENTARIO */}
          <Route path="inventario" element={<InventarioView />} />
          <Route path="agregar" element={<InventarioForm />} />

          {/* CONTRATOS */}
          <Route path="contratos" element={<ContratosView />} />
          <Route path="contratos/agregar" element={<ContratoForm />} />
          <Route path="contratos/editar/:id" element={<ContratoForm />} />

          {/* SITIOS */}
          <Route path="sitios" element={<CredencialesView />} />
          <Route path="sitios/nuevo" element={<CredencialForm />} />
          <Route path="sitios/editar/:id" element={<CredencialForm />} />

          {/* INCIDENCIAS */}
          <Route path="incidencias" element={<IncidenciasListado />} />
          <Route path="incidencias/crear" element={<IncidenciasCrear />} />

          {/* REEMPLAZOS */}
          <Route path="reemplazos" element={<ReemplazosView />} />

          {/* REPORTES */}
          <Route
            path="reportes/comparativo"
            element={<ReportesComparativo />}
          />

          {/* CONFIG */}
          <Route path="configuracion" element={<Configuracion />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}
